export default {
  title: {
    notFound: 'Not found',
    error: 'Error',
    legal: 'Legal',
    identityConcession: 'Identity concession',
    actData: 'Driver data',
    okData: 'Data saved successfully',
    identityDriver: 'Identity driver',
    signDriverData: 'Check your data',
    signDriverCompleted: 'Act signed'
  },
  message: {
    generic: {
      loadingData: 'Loading data',
      loadingDocuments: 'Loading documents'
    },
    warning: {
      checkMessageAllRequired: 'You must select each of the options as appropriate',
      allChecksRequired: 'All fields must be marked'
    }
  },
  language: {
    en: 'English',
    es: 'Spanish'
  },
  ui: {
    button: {
      btnBack: 'Back',
      btnSave: 'Save',
      btnCancel: 'Cancel',
      btnAccept: 'Accept',
      btnClose: 'Close',
      btnCreate: 'Create',
      btnConfirm: 'Confirm',
      btnChange: 'Change',
      btnDelete: 'Delete',
      btnRecord: 'Save',
      btnClear: 'Clear',
      btnAcceptAndContinue: 'Accept and continue',
      btnAddAttorney: 'Add new Attorney',
      btnRemoveAttorney: 'Remove attorney',
      btnsign: 'Sign now',
      btnYes: 'Yes',
      btnNo: 'No',
      btnValidating: 'Validating...',
      btnDriverGuide: 'Driver guide'
    },
    label: {
      step1: 'Login',
      accordionIdentity: 'Confirm your identity',
      allDataRequired: 'All data are required'
    },
    placeholder: {
      cifDniConcession: 'DNI/CIF',
      zipCode: 'Zip code',
      vehicleId: 'Vehicle Id',
      vin: 'Vin',
      lessee: 'lessee',
      cifnif: 'CIF/NIF',
      numContract: 'Num contract lessee',
      customerData: 'Customer information',
      receiverData: 'Deliverer information',
      name: 'Name',
      nameComplete: 'Name and Surname',
      lastname: 'Surname',
      lastname2: 'Second surname',
      dni: 'DNI',
      drivingLicenseDueDate: 'Due Date Driving License',
      version: 'Version',
      carData: 'Car Information',
      brand: 'Brand',
      modelName: 'Model',
      currentKilometers: 'Current Kilometers',
      kmCount: 'Vehicle km count reading',
      colorName: 'Color',
      engineType: 'Combustible',
      transmission: 'Shift car',
      deliveryCity: 'Delivery City',
      documentationDeliveredData: 'Documentation Delivered',
      equipmentDeliveredData: 'Equipment Delivered',
      accessoriesData: 'Accessories',
      genre: 'Genre',
      profession: 'Profession',
      birthDate: 'Borth Date',
      maritalStatus: 'Marital Status',
      email: 'Email',
      mobilePhone: 'Mobile Phone',
      streetType: 'Street Type',
      address: 'Address',
      postCode: 'Post Code',
      town: 'Town',
      documentTypes: 'Document Type',
      documentId: 'Document Number (DNI, NIE)',
      documentIdPass: 'DNI/NIE/Passport',
      businessName: 'Business Name',
      cif: 'CIF',
      companyData: 'Company information',
      contactData: 'Contact information',
      attorneyData: 'Attorney information',
      documentsData: 'Documents',
      companyName: 'Business name',
      constitutionDate: 'Constitution Date',
      fax: 'Fax',
      registeredOffice: 'Registered Office',
      signType: 'Tipo de firma',
      phone: 'Phone',
      selectFile: 'Select File',
      comments: 'Act comments',
      providerComment: 'Act comments',
      driverProviderComment: 'Act comments - Concession',
      driverDriverComment: 'Act comments - Driver',
      cancelModalTitle: 'Cancel act',
      loadingModalTitle: 'Processing...',
      cancelModalText: 'Are you sure you want to cancel the act?',
      cancelModalInputLabel: 'Enter the reason for the cancellation',
      documentInvalid: 'Documents invalid.',
      checksMessageModalTitle: 'Save',
      checksMessageModalText:
        'You have not marked all the checks in any of the Delivered Documentation and Delivered Equipment sections, but if you want to continue, click on the Accept button. Also remember that you can leave us a comment so that we can communicate with the driver',
      dataSavedOk: 'The data has been saved successfully',
      errorValidationProcess: 'Validation process failed.',
      advice: 'Important announcement!',
      errorIdentityDefault:
        'With the data you have provided us there is no active driver. If you wish, contact us. Thank you.',
      errorConcessionsDefault:
        'With the data you have provided us, there are no active concessions. If you wish, contact us. Thanks.',
      errorGetConcessionsDefault:
        'Unexpected error, you can try again later or contact us for more information.',
      actSigned: 'Act Signed',
      signLoadingText:
        'Your signature is being processed. Please do not close the browser, it may take several seconds.',
      showFilesModal: {
        title: 'Documents uploaded',
        error: 'Error'
      },
      showFiles: 'Show files'
    }
  }
};
